module.exports = __webpack_public_path__ + "static/media/logo.733294ea.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.gif
// module id = 260
// module chunks = 15